import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, inject, signal } from '@angular/core';
import { CropperPosition, ImageCroppedEvent, ImageCropperComponent, ImageCropperModule } from 'ngx-image-cropper';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'lib-signing-pad',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, ImageCropperModule, NgClass, FormsModule],
  template: `
  @if (disabled) {
    <div class="gray-block" 
      [style.width]="width + 'px'"
      [style.height]="height + 'px'"
    ></div>

  } @else {

    <div [ngClass]="{'d-none': step !== 'sign'}" class="h-100 w-100" id="canvas-container">
      <h2>Sign Below:
        <!-- Auto crop was requested to always be enabled. -->
        <!-- <mat-checkbox 
          class="float-right" 
          color="primary" 
          matTooltip="Automatically crop and confirm signature."
          [(ngModel)]="autoCrop" 
        >Auto-Crop</mat-checkbox> -->
      </h2>

      <canvas #canvas [width]="width" [height]="height"></canvas> 
      <div class="p-ab-bottom mt-3">
        <button mat-raised-button class="mr-3" (click)="clearPad()">Clear <mat-icon iconPositionEnd>block</mat-icon></button>
        <button mat-raised-button cdkFocusInitial color="primary" (click)="savePad()" [disabled]="(!signaturePad || signaturePad.isEmpty()) || false">Submit Signature <mat-icon iconPositionEnd>save</mat-icon> </button>
        
        @if(showCloseButton) {
          <button mat-button color="warn" class="float-right" (click)="closed.emit(currentSignature)">Close <mat-icon>cancel</mat-icon></button>
        }
      </div>
    </div>

    <!-- Used for AutoCrop only as a simple way to quickly crop the signature. d-none causes errors. -->
    @if (autoCrop && currentSignature) {
      <image-cropper
      #hiddenCropper
      style="opacity: 0; position: absolute; top: -8000px; left: -8000px; mouse-events: none;"
      output="base64"
      format="png"
      [autoCrop]="false"
      [cropperMinWidth]="250"
      [cropperMinHeight]="100"
      [imageBase64]="currentSignature"
      [maintainAspectRatio]="false"
      [aspectRatio]="5 / 2"
      [cropper]="assumedPosition()"
      (imageCropped)="imageCropped($event)"
      (cropperReady)="assumeCropperPosition(true); "
    ></image-cropper>
    }

    @if (step === 'crop') {
    <h2>Signature: Crop</h2>
    <image-cropper
      output="base64"
      format="png"
      [cropperMinWidth]="250"
      [cropperMinHeight]="100"
      [imageBase64]="currentSignature"
      [maintainAspectRatio]="false"
      [aspectRatio]="5 / 2"
      [cropper]="assumedPosition()"
      (imageCropped)="imageCropped($event)"
      (cropperReady)="assumeCropperPosition()"
    ></image-cropper>

    <div class="p-ab-bottom mt-3">
        <button mat-button class="mr-3" (click)="step = 'sign';">Back</button>
        <button mat-raised-button color="primary" (click)="step = 'confirm'">Crop</button>
        @if(showCloseButton) {
          <button mat-button color="warn" class="float-right" (click)="closed.emit(currentSignature)">Close</button>
        }
    </div>
    } @else if (step === 'confirm') {
    <div class="flex-column space-between h-100">
      <h2>Signature: Confirm</h2>
      <div class="flex-center">
          <img [src]="cropped" class="signature-border"/>
      </div>

      <div class="mt-3 p-3">
          <button mat-button class="mr-3" (click)="step = 'crop'; assumeCropperPosition();">Back</button>
          <button mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
          @if(showCloseButton) {
            <button mat-button color="warn" class="float-right" (click)="closed.emit(currentSignature)">Close</button>
          }
      </div>
    </div>
    }
  }

  `,
  styles: [`
    ::ng-deep {
      .dark-theme {
        canvas, .gray-block {
          background-color: #ffffff50;
        }

        .signature-border {
          border: 2px solid rgb(233 233 233 / 42%) !important;
          background-color: #878787;
          background-image: linear-gradient(45deg, rgb(233 233 233 / 42%) 25%, transparent 25%), 
                        linear-gradient(-45deg, rgb(233 233 233 / 42%) 25%, transparent 25%), 
                        linear-gradient(45deg, transparent 75%, rgb(233 233 233 / 42%) 75%), 
                        linear-gradient(-45deg, transparent 75%, rgb(233 233 233 / 42%) 75%) !important;
        }
    }
      .light-theme {
        image-cropper {
          --cropper-outline-color: rgba(48, 48, 48, 0.333);
        }
      }
    }

    :host {
      padding: 0 1rem;
    }

    h2 {
      padding-top: 1rem;
    }

    image-cropper {
      padding: 0;
      // --cropper-outline-color: rgba(48, 48, 48, 0.333);
      --cropper-overlay-color: transparent;
    }

    canvas {
      cursor: url('assets/icons/sign_pen.png') 5 35, auto;
      margin: 0 auto;
    }

    canvas, .gray-block {
      display: block;
      border: 1px solid rgb(187, 178, 178);
    }

    .signature-border {
      border: 2px solid #80808088;
      background-image: linear-gradient(45deg, #80808088 25%, transparent 25%), 
                        linear-gradient(-45deg, #80808088 25%, transparent 25%), 
                        linear-gradient(45deg, transparent 75%, #80808088 75%), 
                        linear-gradient(-45deg, transparent 75%, #80808088 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }

    .p-ab-bottom {
      width: calc(100% - 2rem);
      position: absolute;
      bottom: 1rem;
    }

    .space-between {
      justify-content: space-between;
    }

    .gray-block {
      cursor: not-allowed !important;
    }
  `]
})
export class SigningPadComponent implements AfterViewInit {

  // #region Variables

  /**
   * The current signature in base64 format.
   *
   * @type {string} Base64 string of the signature.
   */
  @Input()
  public currentSignature!: string;

  /**
   * Show the close button in the confirm step.
   */
  @Input()
  public showCloseButton = false;

  @Input()
  public height: number | undefined = undefined;
  // public height: number | undefined = 200;

  @Input()
  public width: number | undefined = undefined;
  // public width: number | undefined = 700;

  /**
   * When disabled, show a greyed out block instead of the signing pad.
   */
  @Input()
  public disabled = false;

  /**
   * Whether the user has signed or not.
   */
  @Input()
  public hasSigned = false;
  @Output()
  public hasSignedChanged = new EventEmitter<boolean>();

  /**
   * Emits the base64 string of the cropped image.
   */
  @Output()
  public submitted = new EventEmitter<string>();

  /**
   * Used to tell the parent component that the dialog can be closed.
   *
   * @memberof SigningPadComponent
   */
  @Output()
  public closed = new EventEmitter<string>();

  /**
   * Setter for the canvas element.
   * The first query will be undefined, so we need to wait for the canvas element to be set.
   *
   * @memberof SigningPadComponent
   */
  @ViewChild('canvas') set canvasElSetter(canvasEl: ElementRef) {
    setTimeout(() => {
      this.setCanvasElementAndEvents(canvasEl);
    });
  }

  @ViewChild(ImageCropperComponent)
  public hiddenCropper: ImageCropperComponent | null = null;

  /**
   * The current step in the signing process.
   * 'sign' - The user is signing.
   * 'crop' - The user is cropping the signature.
   * 'confirm' - The user is confirming the signature.
   *
   * @type {('sign' | 'crop' | 'confirm')}
   */
  public step: 'sign' | 'crop' | 'confirm' = 'sign';

  /**
   * The canvas element.
   */
  private canvasEl!: Element;

  /**
   * Used to track the stroke events while the user is signing.
   * This is later used to estimate the crop position around where the user has signed.
   * The X and Y positions are relative to the container, not to the window or document.
   * E.g: { x: 10, y: 20, type: 'start' } would be the start of a stroke at 10, 20 on the canvas.
   *
   * @type {({ x: number, y: number, type: 'start' | 'end' | 'move' }[])} 
   */
  private strokeEvents: { x: number, y: number, type: 'start' | 'end' | 'move' }[] = [];

  /**
   * The assumed position of the crop, calculated from the strokeEvents.
   */
  // public assumedPosition: CropperPosition = { x1: 0, y1: 0, x2: 100, y2: 100 };
  public assumedPosition = signal<CropperPosition>({ x1: 0, y1: 0, x2: 100, y2: 100 });

  /**
   * Cropped image in base64 format.
   */
  public cropped!: string;

  /**
   * Automatically crop crop and confirm the signature.
   */
  public autoCrop = true;

  /**
   * The signature pad instance from the signature_pad library.
   */
  public signaturePad!: SignaturePad;
  // #endregion

  /**
   * Listen for window resize events to update the canvas size.
   * This will reset the canvas content.
   */
  @HostListener('window:resize', ['$event'])
  public onResize() {
    if (!this.width && !this.height && !this.disabled) {
      this.updateCanvasSize();
    }
  }
  private snackbar = inject(MatSnackBar);

  public ngAfterViewInit(): void {
    // If the width or height are not set, update the canvas size to expand to the container.
    if ((!this.width && !this.height && !this.disabled)) {
      setTimeout(() => {
        this.updateCanvasSize();
      });
    }
  }

  /**
   * Update the canvas size to fit the container.
   * This will reset the canvas content.
   */
  private updateCanvasSize() {
    const canvasContainer = document.getElementById('canvas-container') as HTMLElement;
    if (canvasContainer) {
      // 2px for the canvas border.
      const newWidth = canvasContainer.clientWidth - 2;
      // 36px for the title, 24px for the buttons, 50px for the buttons container, 2px for the canvas border, 32px for the padding.
      const newHeight = canvasContainer.clientHeight - 36 - 24 - 50 - 2 - 32;

      this.width = newWidth;
      this.height = newHeight;
    }
  }

  // #region Signature Pad

  /**
   * Clear the signature pad and the stroke events.
   */
  public clearPad() {
    this.signaturePad.clear();
    this.strokeEvents = [];
  }

  /**
   * Save the signature pad content and move to the crop step.
   */
  public savePad() {
    if (this.signaturePad.isEmpty()) {
      this.snackbar.open('Please sign before continuing.', 'Dismiss');
    } else {
      const base64Data = this.signaturePad.toDataURL();
      this.currentSignature = base64Data;
      if (!this.autoCrop) {
        this.step = 'crop';
      } else {
        // Do nothing, as setting the current signature will trigger the auto crop via the HTML events.
        // When the <ngx-image-cropper> is ready, it will trigger the auto crop.
      }
    }
  }

  public performAutoCrop(event: ImageCroppedEvent | null) {
    // Should be the same thing.
    const base64 = event?.base64 || this.cropped;
    if (base64) {
      // Emit the base64 string.
      this.submitted.emit(base64);
      this.hasSigned = this.signaturePad.isEmpty();
      this.hasSignedChanged.emit(this.hasSigned);

      // Close the dialog.
      if (this.showCloseButton) {
        this.closed.emit(base64);
      }
    } else {
      this.step = 'crop';
    }
  }

  /**
   * Set the canvas element and add the event listeners.
   */
  private setCanvasElementAndEvents(canvasEl: ElementRef<any>) {
    if (canvasEl && !this.signaturePad) { // If the status of disabled changes, this will be called.
      this.signaturePad = new SignaturePad(canvasEl.nativeElement);
      this.canvasEl = canvasEl.nativeElement;

      this.signaturePad.addEventListener('beginStroke', (event) => {
        this.onStrokeStart(event);
      });

      this.signaturePad.addEventListener('endStroke', (event) => {
        this.onStrokeEnd(event);
      });

      this.signaturePad.addEventListener('beforeUpdateStroke', (event) => {
        this.onStrokeMove(event);
      });
    }
  }

  //#endregion
  // #region Image Cropper

  /**
   * Track the start of the stroke and log the X/Y position into the strokeEvents array.
   */
  private onStrokeStart(event: any) {
    // Get offset of the canvas to get the relative mouse position.
    const rect = this.canvasEl.getBoundingClientRect();
    let x = event.detail.clientX - rect.left;
    let y = event.detail.clientY - rect.top;
    // Ensure X/Y are within the canvas. If they are not, set them to the canvas width/height or 0.
    x = Math.min(Math.max(0, x), rect.width);
    y = Math.min(Math.max(0, y), rect.height);
    // Track the start of the stroke.
    this.strokeEvents.push({ x, y, type: 'start' });
  }

  /**
   * Track the end of the stroke and log the X/Y position into the strokeEvents array.
   */
  private onStrokeEnd(event: any) {
    // Get offset of the canvas to get the relative mouse position.
    const rect = this.canvasEl.getBoundingClientRect();
    let x = event.detail.clientX - rect.left;
    let y = event.detail.clientY - rect.top;
    // Ensure X/Y are within the canvas. If they are not, set them to the canvas width/height or 0.
    x = Math.min(Math.max(0, x), rect.width);
    y = Math.min(Math.max(0, y), rect.height);
    // Track the end of the stroke.
    this.strokeEvents.push({ x, y, type: 'end' });
  }

  /**
   * Track the movement of the strokes and log the X/Y position into the strokeEvents array.
   */
  private onStrokeMove(event: any) {
    // Get offset of the canvas to get the relative mouse position.
    const rect = this.canvasEl.getBoundingClientRect();
    let x = event.detail.clientX - rect.left;
    let y = event.detail.clientY - rect.top;
    // Ensure X/Y are within the canvas. If they are not, set them to the canvas width/height or 0.
    x = Math.min(Math.max(0, x), rect.width);
    y = Math.min(Math.max(0, y), rect.height);
    // Track the movement of the stroke.
    this.strokeEvents.push({ x, y, type: 'move' });
  }

  /**
   * Assume the crop position based on the stroke events.
   * 
   * @param {boolean} [doCrop=false] Whether to crop the image after assuming the position.
   */
  public assumeCropperPosition(doCrop = false): void {
    const xMin = this.strokeEvents.reduce((acc, curr) => Math.min(acc, curr.x), this.strokeEvents[0].x);
    const yMin = this.strokeEvents.reduce((acc, curr) => Math.min(acc, curr.y), this.strokeEvents[0].y);
    const xMax = this.strokeEvents.reduce((acc, curr) => Math.max(acc, curr.x), this.strokeEvents[0].x);
    const yMax = this.strokeEvents.reduce((acc, curr) => Math.max(acc, curr.y), this.strokeEvents[0].y);
    const position = { // Add some padding to the crop.
      x1: xMin - 10,
      y1: yMin - 10,
      x2: xMax + 10,
      y2: yMax + 10
    };
    // this.assumedPosition = position;
    this.assumedPosition.set(position);

    if (doCrop) {
      // Do on next cycle, so that the cropper can register the new dimensions.
      setTimeout(() => {
        this.performAutoCrop(this.hiddenCropper?.crop() || null)
      });
    }
  }

  /**
   * Crop the image and move to the confirm step.
   */
  public imageCropped(event: ImageCroppedEvent) {
    if (event.base64) {
      this.cropped = event.base64;
    } else {
      this.snackbar.open('Please crop the signature before continuing.', 'Dismiss');
    }
  }

  //#endregion

  public onConfirm() {
    this.submitted.emit(this.cropped);
    this.hasSigned = this.signaturePad.isEmpty();
    this.hasSignedChanged.emit(this.hasSigned);

    if (this.showCloseButton) {
      this.closed.emit(this.currentSignature);
    }
  }

}
